const SemVerGte = require('semver/functions/gte')
const SemVerLte = require('semver/functions/lte')
const SemVerSatisfies = require('semver/functions/satisfies')
const {
  fields: privacySettingsConfig
} = require('cloud-utils/config/device-privacy-mode-config/privacy-mode-settings.json')

const privacySettingsUI = JSON.parse(
  JSON.stringify(
    privacySettingsConfig.filter(
      setting => setting.configure.allowInUI !== false
    )
  )
)
angular
  .module('surfsightApp.controllers')
  .controller('PrivacyModeSettingsEditController', [
    '$scope',
    '$filter',
    '$localStorage',
    function ($scope, $filter, $localStorage) {
      const $translate = $filter('translate')
      $scope.bulkDevicesSelected = false
      if ($scope.showPrivacyModeControl !== false) {
        $scope.privacyMode = $scope.privacyMode || null
        $scope.showPrivacyModeControl = true
      }
      if ($scope.selectedBulkDevices !== undefined) {
        $scope.bulkDevicesSelected = true
      }
      $scope.config = {
        ...$scope.editConfig,
        submitLabel: 'save',
        cancelLabel: 'cancel',
        backLabel: 'back',
        privacyModeLabel: 'privacyModeLabel'
      }
      const supportFromVersion = fromVersion => {
        if (!fromVersion || !$scope.version) return true
        return SemVerGte($scope.version, fromVersion)
      }
      $scope.uiPrivacySettingsFields = JSON.parse(
        JSON.stringify(
          privacySettingsUI.filter(
            ({ fromVersion }) =>
              !$scope.version || !fromVersion || supportFromVersion(fromVersion)
          )
        )
      )
      $scope.isRestrictedUser =
        $localStorage.userDetails.accessLevel === 'viewer'
      $scope.updatePrivacyMode = function (privacyMode) {
        $scope.privacyMode = privacyMode
      }
      $scope.submitPrivacySettings = function () {
        $scope.onSubmit()
      }
    }
  ])
